import React, { useRef, useState } from 'react';
import { Mic, Square, Trash2, Loader2 } from 'lucide-react';

const RATE = 0.78;

function toWav(buf) {
  const ch = buf.getChannelData(0); const sr = buf.sampleRate; const out = new DataView(new ArrayBuffer(44 + ch.length * 2));
  const w = (o, s) => [...s].forEach((c, i) => out.setUint8(o + i, c.charCodeAt(0)));
  w(0, 'RIFF'); out.setUint32(4, 36 + ch.length * 2, true); w(8, 'WAVEfmt '); out.setUint32(16, 16, true); out.setUint16(20, 1, true); out.setUint16(22, 1, true);
  out.setUint32(24, sr, true); out.setUint32(28, sr * 2, true); out.setUint16(32, 2, true); out.setUint16(34, 16, true); w(36, 'data'); out.setUint32(40, ch.length * 2, true);
  ch.forEach((v, i) => out.setInt16(44 + i * 2, Math.max(-1, Math.min(1, v)) * 0x7fff, true));
  return new Blob([out], { type: 'audio/wav' });
}

async function alter(blob) {
  const ctx = new (window.AudioContext || window.webkitAudioContext)();
  const src = await ctx.decodeAudioData(await blob.arrayBuffer());
  const off = new OfflineAudioContext(1, Math.ceil(src.length / RATE), src.sampleRate);
  const node = off.createBufferSource(); node.buffer = src; node.playbackRate.value = RATE;
  const shaper = off.createBiquadFilter(); shaper.type = 'lowshelf'; shaper.frequency.value = 300; shaper.gain.value = 6;
  node.connect(shaper).connect(off.destination); node.start();
  const wav = toWav(await off.startRendering()); ctx.close(); return wav;
}

export default function WbVoice({ value, onChange }) {
  const [state, setState] = useState('idle');
  const rec = useRef(null);
  const start = async () => {
    try {
      const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
      const mr = new MediaRecorder(stream); const parts = [];
      mr.ondataavailable = (e) => parts.push(e.data);
      mr.onstop = async () => { stream.getTracks().forEach((t) => t.stop()); setState('busy'); onChange(await alter(new Blob(parts, { type: mr.mimeType }))); setState('idle'); };
      mr.start(); rec.current = mr; setState('rec');
    } catch { alert('Microfono non disponibile: controlla i permessi del browser.'); }
  };
  return (
    <div className="border border-[#2A2F37] p-4 space-y-3" data-testid="wb-voice">
      <p className="text-xs text-[#8A8F97]">La voce viene alterata nel tuo browser prima dell'invio: l'audio originale non lascia mai il tuo dispositivo.</p>
      {state === 'rec' ? <button type="button" onClick={() => rec.current.stop()} className="h-11 px-4 bg-[#E37A72] text-black inline-flex items-center gap-2" data-testid="wb-voice-stop"><Square size={14} />Termina registrazione</button>
        : state === 'busy' ? <p className="text-sm flex items-center gap-2"><Loader2 size={14} className="animate-spin" />Alterazione della voce…</p>
          : <button type="button" onClick={start} className="h-11 px-4 border border-[#D4AF37] text-[#D4AF37] inline-flex items-center gap-2" data-testid="wb-voice-start"><Mic size={14} />{value ? 'Registra di nuovo' : 'Registra il messaggio vocale'}</button>}
      {value && state === 'idle' && <div className="flex items-center gap-3"><audio controls src={URL.createObjectURL(value)} data-testid="wb-voice-preview" /><button type="button" onClick={() => onChange(null)} className="text-[#E37A72]" data-testid="wb-voice-delete"><Trash2 size={16} /></button></div>}
    </div>
  );
}
